import User from './models'

export default User
